import $ from 'jquery'

function closeSelect2(){
  $( document ).on( 'click', function(){
    $('.select2-container').select2('close')
  })
}

export { closeSelect2 }